<template>
    <div class="contact-wrap">
        <h2>{{$t('newblock.videoOverlay.contact.heading')}}</h2>
        <div class="form">
            <div class="input-wrap">
                <label>{{$t('register.email')}}:</label>
                <input v-model.trim="email" @blur="emailError = null">
                <small v-if="emailError">{{ emailError }}</small>
            </div>
            <div class="input-wrap" v-if="item.type === 'contact'">
                <label>{{$t('newblock.videoOverlay.contact.phone')}}:</label>
                <input v-model.trim="phone" @blur="phoneError = null">
                <small v-if="phoneError">{{ phoneError }}</small>
            </div>
            <div class="input-wrap">
                <label>{{$t('newblock.videoOverlay.contact.message')}}:</label>
                <textarea v-model.trim="message" @blur="messageError = null"></textarea>
                <small v-if="messageError">{{ messageError }}</small>
            </div>
        </div>
        <div class="button-line">
            <button @click="onSendInfo">
                {{$t('newblock.helpPage.submitForm.send')}}
                <span><img :src="$images.sendIcon" alt="sendIcon.png"></span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
        },
    },
    data() {
        return {
            email: '',
            emailError: null,

            phone: '',
            phoneError: null,

            message: '',
            messageError: null,
        };
    },
    mounted () {
        this.init();
    },
    methods: {
        async init () {
          if (Object.entries(this.user).length > 0) this.email = this.user.email;
        },
        onSendInfo () {
            this.clearErrors();
            if (this.hasErrors()) return;
            
            this.sendInfo();
        },
        async sendInfo () {
          const params = {
              con_id: this.item.con_id,
              type: this.item.type,
              email: this.email,
          };
          if (this.phone) params.phone = this.phone;
          if (this.message) params.msg = this.message;

          this.$emit('send-info', params);
        },
        clearErrors () {
            this.emailError = null;
            this.phoneError = null;
            this.messageError = null;
        },
        hasErrors () {
            let errorCount = 0;

            const isEmailValid = /^(\w+.?)+@(\w+.?)+.\w+$/.test(this.email);
            if (!isEmailValid || this.email.length === 0) {
                this.emailError = this.$t('register.emailError');
                errorCount++
            }

            if (this.phone.length > 254) {
                this.phoneError = this.$t('newblock.videoOverlay.contact.phoneLengthError');
                errorCount++
            }

            if (this.message.length > 500) {
                this.messageError = this.$t('newblock.videoOverlay.contact.messageLengthError');
                errorCount++
            }

            return errorCount > 0;
        },
    },
}
</script>

<style lang="scss" scoped>
.contact-wrap {
    .form {
        display: flex;
        flex-direction: column;
        gap: 1em; 
        .input-wrap {
            display: flex;
            flex-direction: column;
            textarea {
                max-width: 800px;
                max-height: 400px;
            }
            small {
                color: red;
            }
        }
    }
    .button-line {
        padding: 1em;
        display: flex;
        justify-content: center;
        align-items: center;
        button {
            font-family: 'Roboto';
            font-size: 16px;
            font-weight: 500;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: .6em;
            padding: 20px 5px;
            min-width: 172px;
            height: 39px;
            border-radius: 5px;
            border: none;
            cursor: pointer;
            outline: none;
            background-color: rgb(47, 128, 237);
        }
    }
}
</style>